export default __webpack_public_path__ + "static/media/image00025.a8777a61.jpeg";